export default "__VITE_ASSET__SAt6VDox__"